module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.10790/images/homepage/company-logos/alelo.svg"